import { Box, Flex, useMediaQuery, Text, Stack, Image } from "@chakra-ui/react";
import React from "react";
import Socials from "../components/Socials";
import BackgroundAnimation from "./animation";
import Logo from "./logo";
import Newnav from "./newnav";
import Picture from "./picture";
import Terminal from './Terminal'

function Header() {
  const [isNotSmall] = useMediaQuery("(min-width: 1100px)");

  return (
    <div style={ isNotSmall ? { height: "100vh", display: 'flex',alignItems:'center',justifyContent:'center',marginTop:'40px'}: {  display: 'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',marginTop:'20px'}}>
      <Flex
        direction={isNotSmall ? "row" : "column"}
        alignSelf={"flex-start"}
        justifyContent={'center'}
        alignItems={'center'}
        pl={isNotSmall ? 20 : 12}
        pr={isNotSmall ? 20 : 12}
        mb={'100px'}
      >
        <Box mt={isNotSmall ? 16 : 0} mr={30}>
          <Text fontSize={isNotSmall ? "5xl" : "4xl"} fontWeight={"semibold"}>
            Hey 👋,
          </Text>
          <Text
            fontSize={isNotSmall ? "7xl" : "5xl"}
            fontWeight={"semibold"}
            bgGradient={"linear(to-r,teal.400, cyan.400)"}
            bgClip={"text"}
          >
            I'm Hamza Al Sorkhy {}
          </Text>
          <Text fontSize={isNotSmall ? "xl" : "m"}>
            {" "}
            I'm a  mobile and web developer with a passion for
            UI/UX design. {<br/>} I use Flutter and ReactJS to make stunning front ends for mobile applications and webpages alike.{" "}
          </Text>
          {/* <Socials /> */}
          
        </Box> 
      <Logo/>
      </Flex>
      {/* { isNotSmall ? <div style={{width:'500px'}}><BackgroundAnimation /> </div> : <div></div> } */}
      
     
    </div>
  );
}

export default Header;
